var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import ShopActivityService from '../../api/ShopActivityService';
import GLOBAL_VUE from '../../globalVue';
import GoodsList from './components/GoodsList';
import ClientsList from './components/ClientsList';
var unqFullMinusId = 1;
var FullMinusItem = {
    full: null,
    minus: null,
};
var unqRebateId = 1;
var rebateItem = {
    min: null,
    max: null,
    rebate: null,
    unit: '%',
};
var rebateEachItem = {
    full: null,
    rebate: null,
    unit: '%',
};
var integralEachItem = {
    proportion: null,
    point: null,
    money: null,
    status: false,
    days: null
};
var initFormData = {
    activity_type: 1,
    activity_sub_type: 11,
    fullMinusList: [__assign({}, FullMinusItem, { unqFullMinusId: unqFullMinusId })],
    fullGiftAmountData: null,
    fullGiftQuantityData: null,
    rebateList: [__assign({}, rebateItem, { unqRebateId: unqRebateId })],
    rebateEach: __assign({}, rebateEachItem),
    goods_type: 1,
    goodsListData: [],
    giftListData: [],
    integralEach: __assign({}, integralEachItem),
    business_type: 1,
    businessListData: [],
    activity_business: null,
    activity_business_clients: null,
    update_business: 0,
};
var ShopActivityAdd = (function (_super) {
    __extends(ShopActivityAdd, _super);
    function ShopActivityAdd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activity_id = '';
        _this.formData = __assign({}, initFormData);
        _this.buttonAuth = {
            Add: false,
            Able: false,
            LookDetail: false,
            Modify: false,
        };
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() < Date.now() - 86400000;
            },
        };
        _this.rebateUnitList = [
            { value: '%' },
            { value: '元' }
        ];
        return _this;
    }
    ShopActivityAdd.prototype.watchStatus = function (newVal, oldVal) {
        if (newVal == false) {
            this.formData.integralEach.days = '';
        }
    };
    ShopActivityAdd.prototype.created = function () {
        var _this = this;
        this.service = ShopActivityService.getInstance();
        if (this.activity_id) {
            this.getDetail();
        }
        this.getAuth('310004').then(function (pageAuth) {
            Object.assign(_this.buttonAuth, pageAuth && pageAuth.Auth);
        });
    };
    ShopActivityAdd.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            activity_id: this.activity_id,
        };
        this.service
            .getDetail(Object.assign({}, params))
            .then(function (res) {
            loadingInstance.close();
            var data = {};
            data = res.data && res.data.data;
            data.activity_time = [data.start_date, data.end_date];
            delete data.start_date;
            delete data.end_date;
            if (data.activity_type == 1) {
                data.fullMinusList = (data.rule || []).map(function (item) {
                    return {
                        full: item.full,
                        minus: item.reduction,
                    };
                });
            }
            else if (data.activity_type == 2) {
                if (data.activity_sub_type == 21) {
                    data.fullGiftAmountData = data.rule && data.rule.full;
                }
                else if (data.activity_sub_type == 22) {
                    data.fullGiftQuantityData = data.rule && data.rule.full;
                }
            }
            else if (data.activity_type == 3) {
                if (data.activity_sub_type == 31) {
                    data.rebateList = JSON.parse(JSON.stringify(data.rule));
                }
                else if (data.activity_sub_type == 32) {
                    var rebateEachItem_1 = data.rule[0] || {};
                    data.rebateEach = __assign({}, rebateEachItem_1);
                }
            }
            else if (data.activity_type == 4) {
                var integralitem1 = data.rule.exchange;
                data.rule.protection_period.status = data.rule.protection_period.status == 1 ? true : false;
                var integralitem2 = data.rule.protection_period;
                data.integralEach = __assign({}, integralitem1, integralitem2, { 'proportion': data.rule.proportion, 'days': data.rule.protection_period.days });
            }
            delete data.rule;
            data.businessListData = data.business_info || [];
            delete data.business_info;
            var supplier_to_business_ids = [];
            (data.businessListData || []).forEach(function (item) {
                if (item.supplier_to_business_id) {
                    supplier_to_business_ids.push(item.supplier_to_business_id);
                }
            });
            var shopIds = data.shop_ids || [];
            shopIds.forEach(function (shop) {
                supplier_to_business_ids.push(shop.shop_id + '_' + shop.supplier_to_business_id + '_' + shop.business_id);
            });
            data.activity_business_clients = {
                supplier_to_business_ids: supplier_to_business_ids,
                business_ids: data.business_set_ids || [],
                group_ids: data.group_ids,
                shop_ids: shopIds,
            };
            delete data.business_ids;
            delete data.business_set_ids;
            delete data.group_ids;
            delete data.shop_ids;
            data.update_business = 0;
            data.goodsListData = data.activity_goods || [];
            delete data.activity_goods;
            data.giftListData = data.activity_gift_goods || [];
            delete data.activity_gift_goods;
            _this.formData = data;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ShopActivityAdd.prototype.changeActType = function () {
        if (this.formData.activity_type == 1) {
            this.formData.activity_sub_type = 11;
        }
        else if (this.formData.activity_type == 2) {
            this.formData.activity_sub_type = 21;
        }
        else if (this.formData.activity_type == 3) {
            this.formData.activity_sub_type = 31;
        }
        this.formData.fullMinusList = [__assign({}, FullMinusItem, { unqFullMinusId: unqFullMinusId })];
        this.formData.rebateList = [__assign({}, rebateItem, { unqRebateId: unqRebateId })];
        this.formData.integralEach = __assign({}, integralEachItem);
    };
    ShopActivityAdd.prototype.changeActRule = function () {
        unqFullMinusId++;
        this.formData.fullMinusList = [__assign({}, FullMinusItem, { unqFullMinusId: unqFullMinusId })];
        unqRebateId++;
        this.formData.rebateList = [__assign({}, rebateItem, { unqRebateId: unqRebateId })];
        this.formData.rebateEach = __assign({}, rebateEachItem);
    };
    ShopActivityAdd.prototype.addFullMinusItem = function () {
        unqFullMinusId++;
        this.formData.fullMinusList.push(__assign({}, FullMinusItem, { unqFullMinusId: unqFullMinusId }));
    };
    ShopActivityAdd.prototype.deleteFullMinusItem = function (index) {
        var dataClone = _.cloneDeep(this.formData.fullMinusList);
        dataClone.splice(index, 1);
        this.formData.fullMinusList = dataClone;
    };
    ShopActivityAdd.prototype.addRebateItem = function () {
        unqRebateId++;
        this.formData.rebateList.push(__assign({}, rebateItem, { unqRebateId: unqRebateId }));
    };
    ShopActivityAdd.prototype.deleteRebateItem = function (index) {
        var dataClone = _.cloneDeep(this.formData.rebateList);
        dataClone.splice(index, 1);
        this.formData.rebateList = dataClone;
    };
    ShopActivityAdd.prototype.changeGoodsSelect = function (goodsType, list) {
        if (goodsType === 'goods') {
            this.formData.goodsListData = list;
        }
        if (goodsType === 'gift') {
            this.formData.giftListData = list;
        }
    };
    ShopActivityAdd.prototype.changeBusinessSelect = function (res) {
        var businessList = (res && res.business_list) || [];
        this.formData.businessListData = businessList;
        this.formData.activity_business = res;
        this.formData.activity_business_clients = {
            supplier_to_business_ids: res.supplier_to_business_ids || [],
            business_ids: res.business_ids || [],
            group_ids: res.group_ids || [],
            shop_ids: res.shop_ids || [],
        };
        this.formData.update_business = 1;
    };
    ShopActivityAdd.prototype.validateForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isValidBasic, fullMinusList, isFullMinusFlag, _a, activity_sub_type, rebateList, rebateEach, isRebateListFlag, isRebateEachFlag, businessLen, goodsLen, giftLen, isValidTable, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, this['$validator'].validateScopes()];
                    case 1:
                        isValidBasic = _c.sent();
                        if (!isValidBasic) {
                            this.$message.error('请检查表单数据的完整性及正确性');
                            return [2, false];
                        }
                        fullMinusList = this.formData.fullMinusList;
                        isFullMinusFlag = true;
                        (fullMinusList || []).map(function (item) {
                            if (item.full && item.minus && Number(item.full) < Number(item.minus)) {
                                isFullMinusFlag = false;
                                return false;
                            }
                        });
                        if (!isFullMinusFlag) {
                            this.$message.error('满减数据中满需要大于减');
                            return [2, false];
                        }
                        _a = this.formData, activity_sub_type = _a.activity_sub_type, rebateList = _a.rebateList, rebateEach = _a.rebateEach;
                        isRebateListFlag = true;
                        isRebateEachFlag = true;
                        if (activity_sub_type == 31) {
                            (rebateList || []).map(function (item) {
                                if (item.unit === '%') {
                                    if (item.max && item.min && (Number(item.max) < Number(item.min))) {
                                        isRebateListFlag = false;
                                        return false;
                                    }
                                    if (item.rebate && (Number(item.rebate) > 100 || Number(item.rebate) < 0)) {
                                        isRebateListFlag = false;
                                        return false;
                                    }
                                }
                                if (item.unit === '元') {
                                    if (item.max && item.min && (Number(item.max) < Number(item.min))) {
                                        isRebateListFlag = false;
                                        return false;
                                    }
                                    if (item.rebate && (Number(item.rebate) > Number(item.min))) {
                                        isRebateListFlag = false;
                                        return false;
                                    }
                                }
                            });
                        }
                        else if (activity_sub_type == 32) {
                            if (rebateEach.unit === '%' && (rebateEach.rebate > 100 || rebateEach.rebate < 0)) {
                                isRebateEachFlag = false;
                                return [2, false];
                            }
                            if (rebateEach.unit === '元' && (rebateEach.rebate > rebateEach.full)) {
                                isRebateEachFlag = false;
                                return [2, false];
                            }
                        }
                        if (!isRebateListFlag) {
                            this.$message.error('阶梯返利中，输入区间第一个数要小于等于第二个数。单位若是元，返利要小于等于区间最小值。单位若是百分比，返利需要在0-100之间。');
                            return [2, false];
                        }
                        if (!isRebateEachFlag) {
                            this.$message.error('每满返利中，单位若是元，返利要小于等于每满。单位若是百分比，返利需要在0-100之间。');
                            return [2, false];
                        }
                        if (this.formData.business_type == 2) {
                            businessLen = (this.formData.businessListData || []).length;
                            if (businessLen == 0) {
                                this.$message.error('请选择客户');
                                return [2, false];
                            }
                        }
                        if (this.formData.goods_type == 2) {
                            goodsLen = (this.formData.goodsListData || []).length;
                            if (goodsLen == 0) {
                                this.$message.error('请选择货品');
                                return [2, false];
                            }
                        }
                        if (!(this.formData.activity_type == 2)) return [3, 4];
                        giftLen = (this.formData.giftListData || []).length;
                        if (giftLen == 0) {
                            this.$message.error('请选择赠品');
                            return [2, false];
                        }
                        _b = this.$refs.giftGoodsListRef;
                        if (!_b) return [3, 3];
                        return [4, this.$refs.giftGoodsListRef.validTable()];
                    case 2:
                        _b = (_c.sent());
                        _c.label = 3;
                    case 3:
                        isValidTable = _b;
                        if (!isValidTable) {
                            this.$message.error('请检查赠品数量');
                            return [2, false];
                        }
                        _c.label = 4;
                    case 4: return [2, true];
                }
            });
        });
    };
    ShopActivityAdd.prototype.formDataFormat = function () {
        var activity_goods = (this.formData.goodsListData || []).map(function (item) {
            return {
                goods_id: item.goods_id,
                goods_format_id: item.goods_format_id,
            };
        });
        activity_goods = JSON.stringify(activity_goods);
        var gift_goods = (this.formData.giftListData || []).map(function (item) {
            return {
                goods_id: item.goods_id,
                goods_format_id: item.goods_format_id,
                amount: item.amount,
            };
        });
        gift_goods = JSON.stringify(gift_goods);
        var rule = null;
        if (this.formData.activity_type == 1) {
            rule = (this.formData.fullMinusList || []).map(function (item) {
                return {
                    full: item.full,
                    reduction: item.minus,
                };
            });
        }
        else if (this.formData.activity_type == 2) {
            if (this.formData.activity_sub_type == 21) {
                rule = { full: this.formData.fullGiftAmountData };
            }
            else if (this.formData.activity_sub_type == 22) {
                rule = { full: this.formData.fullGiftQuantityData };
            }
        }
        else if (this.formData.activity_type == 3) {
            if (this.formData.activity_sub_type == 31) {
                rule = this.formData.rebateList;
            }
            else if (this.formData.activity_sub_type == 32) {
                rule = [
                    __assign({}, this.formData.rebateEach)
                ];
            }
        }
        else if (this.formData.activity_type == 4) {
            this.formData.activity_sub_type = 0;
            rule = { proportion: this.formData.integralEach.proportion,
                exchange: { point: this.formData.integralEach.point, money: this.formData.integralEach.money },
                protection_period: { status: this.formData.integralEach.status == true ? 1 : 0, days: this.formData.integralEach.days } };
        }
        console.log(777, rule);
        rule = JSON.stringify(rule);
        var activity_business = (this.formData.activity_business && this.formData.activity_business.business_info) || [];
        activity_business = JSON.stringify(activity_business);
        var params = {
            activity_type: this.formData.activity_type,
            activity_sub_type: this.formData.activity_sub_type,
            activity_name: this.formData.activity_name,
            start_date: this.formData.activity_time && this.formData.activity_time[0],
            end_date: this.formData.activity_time && this.formData.activity_time[1],
            goods_type: this.formData.goods_type,
            activity_goods: activity_goods,
            gift_goods: gift_goods,
            business_type: this.formData.business_type,
            activity_business: activity_business,
            update_business: this.formData.update_business,
            rule: rule,
        };
        return params;
    };
    ShopActivityAdd.prototype.save = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var isValid;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.validateForm()];
                    case 1:
                        isValid = _a.sent();
                        if (isValid) {
                            this.$confirm('确定保存该活动吗？').then(function () {
                                var params = _this.formDataFormat();
                                var release = type === 'publish' ? 1 : null;
                                console.log(2222, params);
                                if (_this.activity_id || _this.activity_id == 0) {
                                    var loadingInstance_1 = Loading.service({ fullscreen: true });
                                    _this.service
                                        .update(__assign({}, params, { activity_id: _this.activity_id, release: release }))
                                        .then(function (res) {
                                        loadingInstance_1.close();
                                        _this.$message.success(res.data.msg || '操作成功');
                                        window._czc.push([
                                            '_trackEvent',
                                            '营销活动',
                                            '修改活动',
                                        ]);
                                        setTimeout(function () {
                                            GLOBAL_VUE.$emit("closeTab", _this);
                                            if (_this.opener) {
                                                _this.opener.getList();
                                            }
                                        }, 500);
                                    })
                                        .catch(function (err) {
                                        loadingInstance_1.close();
                                        _this.$message.error(err.msg || err.message);
                                    });
                                }
                                else {
                                    var loadingInstance_2 = Loading.service({ fullscreen: true });
                                    _this.service
                                        .save(__assign({}, params, { release: release }))
                                        .then(function (res) {
                                        loadingInstance_2.close();
                                        _this.$message.success(res.data.msg || '操作成功');
                                        window._czc.push([
                                            '_trackEvent',
                                            '营销活动',
                                            '保存活动',
                                        ]);
                                        setTimeout(function () {
                                            GLOBAL_VUE.$emit("closeTab", _this);
                                            if (_this.opener) {
                                                _this.opener.getList();
                                            }
                                        }, 500);
                                    })
                                        .catch(function (err) {
                                        loadingInstance_2.close();
                                        _this.$message.error(err.msg || err.message);
                                    });
                                }
                            }, function (err) { });
                        }
                        return [2];
                }
            });
        });
    };
    __decorate([
        Watch('formData.integralEach.status', { immediate: true })
    ], ShopActivityAdd.prototype, "watchStatus", null);
    ShopActivityAdd = __decorate([
        Component({
            components: {
                'goods-list': GoodsList,
                'clients-list': ClientsList,
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], ShopActivityAdd);
    return ShopActivityAdd;
}(Vue));
export default ShopActivityAdd;
